export const HEADER_TEST_IDS = <const>{
  menu: 'header.menu',
  newChat: 'header.new-chat',
  modeToggle: 'header.mode-toggle',
  more: 'header.more',
  close: 'header.close',
  menuPin: 'header.menu.pin',
  menuRemove: 'header.menu.remove',
};
